import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CheckboxGroup, Checkbox, Column, FormField } from '@tempmee/react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { CollapsibleCard } from '../../../../commonComponents';
import { SoftwareUtils } from '../../../../utils/SoftwareUtils';
import { useFormContext } from '../../hooks/useFormContext';
import { CardTitle } from '../CardTitle';
import { useSoftware } from './hooks/useSoftware/useSoftware';

export const SoftwareCard = ({ isOpen, onToggle }) => {
  const { setValue, control } = useFormContext();
  const { formValues, isValid } = useSoftware(control);
  const officeEducation = useSelector((state) => state.user.officeEducation);

  const softwares = useMemo(
    () => SoftwareUtils.getSoftwareTranslations(officeEducation?.softwares),
    [officeEducation],
  );

  const handleChange = (updatedValues) => {
    setValue('softwares', [...updatedValues].sort());
  };

  return (
    <CollapsibleCard
      TitleComponent={() => <CardTitle name="Software" showWarningIcon={!isOpen && !isValid} />}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <Column gap={5} px={20} style={{ marginBottom: 40 }}>
        <FormField
          label="What software does your office use?"
          TrailingComponent={
            !isValid ? (
              <SolidExclamationWarningAlertIcon
                width={16}
                height={16}
                color={colors.warning['500']}
              />
            ) : null
          }
        >
          <CheckboxGroup value={formValues.softwares} onChange={handleChange}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 15 }}>
              {softwares?.map((name) => (
                <Checkbox key={name} value={name} label={name} />
              ))}
            </div>
          </CheckboxGroup>
        </FormField>
      </Column>
    </CollapsibleCard>
  );
};
